module.exports = __webpack_public_path__ + "img/undraw_ask_me_anything_k8o0.865dccee.svg";